function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.7607 2.94187C8.57344 2.76351 8.27648 2.77054 8.09812 2.95804C7.91953 3.14554 7.92703 3.44226 8.1143 3.62086L11.7101 7.03124H2.34375C2.085 7.03124 1.875 7.24124 1.875 7.49999C1.875 7.75874 2.085 7.96874 2.34375 7.96874H11.6951L8.1143 11.3794C7.9268 11.558 7.91953 11.8547 8.09812 12.0422C8.19023 12.1387 8.31375 12.1875 8.4375 12.1875C8.55375 12.1875 8.67 12.1446 8.7607 12.0581L12.8503 8.1628C13.0275 7.98585 13.125 7.75054 13.125 7.49999C13.125 7.24945 13.0275 7.01413 12.8421 6.82921L8.7607 2.94187Z",
  fill: "currentColor"
});

var SvgArrowForward = function SvgArrowForward(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowForward, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-forward.1fb1b10e.svg";
export { ForwardRef as ReactComponent };